import { Grid, Typography } from "@mui/material";

type PageHeaderProps = {
  text: string;
  supplement?: any;
  textAfterSupplement?: any;
  leftIcon?: any;
  noIndent?: any;
  tabs?: any;
  marginBottom?: any;
};

export function PageHeader(props: PageHeaderProps) {
  return (
    <Grid
      container
      xs={12}
      className="white"
      marginBottom={props.marginBottom ? props.marginBottom : 1.5}
    >
      <Grid item xs={props.noIndent ? 0 : 0.75}></Grid>
      <Grid
        item
        xs={props.noIndent ? 12 : 10.5}
        textAlign={"left"}
        marginTop={1.5}
        marginBottom={props.marginBottom ? props.marginBottom : 1.5}
      >
        <Typography
          variant="h5"
          fontWeight={600}
          justifyContent={"flex-start"}
          display={"flex"}
        >
          {props.leftIcon ? props.leftIcon : ""}
          {props.text} {props.supplement ? props.supplement : ""}{" "}
          {props.textAfterSupplement ? props.textAfterSupplement : ""}
        </Typography>
        {props.tabs ? props.tabs : ""}
      </Grid>
      <Grid item xs={props.noIndent ? 0 : 0.75}></Grid>
    </Grid>
  );
}
